import { useCallback } from 'react';
import NiceModal from '@ebay/nice-modal-react';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';
import { getLabelMessage } from '@gef-ui/localization/messages';
import CirclePlus from '@gef-ui/material-icons/CirclePlus';

import Subheader from 'components/atoms/GefMui/Subheader';
import ToolbarTemplate from 'components/atoms/GefMui/ToolbarTemplate/ToolbarTemplate';
import MODALS from 'constants/modals';
import { KMP_NEW_CAMPAIGN } from 'features/common/acl/constants';

export const Toolbar = () => {
	const newOrEditCampaignPermission = useSelector((state) => hasPermissionByIds(state)(KMP_NEW_CAMPAIGN));
	const isCampaignSettings = window.location.pathname === '/campaign/settings/list';

	const handleOpenNewCampaignModal = useCallback(() => {
		NiceModal.show(MODALS.new_campaign);
	}, []);

	return (
		<ToolbarTemplate
			leftSide={<Subheader title={getLabelMessage('campaignsList:header')} />}
			rightSide={
				newOrEditCampaignPermission &&
				isCampaignSettings && (
					<Button variant="text" size="small" startIcon={<CirclePlus />} onClick={handleOpenNewCampaignModal}>
						{getLabelMessage('campaignsList:newCampaign')}
					</Button>
				)
			}
		/>
	);
};

export default Toolbar;
